<template>
  <div class="go-back-wrap" @click="goBack" v-if="!isHXApp">
    <img src="../../../assets/images/go-back.png" alt="返回" />
    <span>返回</span>
  </div>
</template>

<script>
import { isHXApp } from "@saas/components/src";
export default {
  data: function () {
    return {
      isHXApp: isHXApp(),
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.go-back-wrap {
  padding: 14px 8px;
  display: flex;
  align-items: center;
  font-size: 14px;
  width: fit-content;
  cursor: pointer;
  img {
    width: 22px;
    height: 22px;
  }
  span {
    margin-left: 10px;
  }
}
@media (max-width: 767px) {
  .go-back-wrap {
    display: flex;
    align-items: center;
    padding: 0.27rem 0.21rem;
    font-size: 0.3733rem;
    width: fit-content;
    img {
      width: 0.53rem;
      height: 0.53rem;
    }
    span {
      margin-left: 0.13rem;
    }
  }
}
</style>
